import { render, staticRenderFns } from "./Contracts.yaml?vue&type=template&id=25607b70&component"
import script from "./Contracts.yaml?vue&type=script&lang=ts&component"
export * from "./Contracts.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports